//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '@/components/Footer.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'NoSidebar',
  components: {
    'postpone-footer': Footer,
    'postpone-topnav': TopNav,
  },
}
